import React, { useState, useEffect, useRef } from "react";

import {
  Button,
  Dialog,
  Grid,
  Icon,
  Typography,
  FormHelperText,
  TextField,
  IconButton
} from "@material-ui/core";
import Scrollbars from "rc-scrollbars";
import CloseIcon from "@material-ui/icons/Close";
import DialogLoader from "../../../../../../../components/Loader/DialogLoader";
import {
  InputBaseField, MultiSelectField, FileInput
} from "../../../../../../../components/InputField/InputField";
import {
  Label,
  DraggableComponent,
} from "../../../../../../../components/UiElements/UiElements";
import { PostDataAPI } from "../../../../../../../Services/APIService";
import { withSnackbar } from "../../../../../../../components/Message/Alert";
import useStyles from "./styles";
import {
  allowedAttachmentsImages
} from "../../../../../../../../src/components/Common/Extensions";


import PreviewIcon from '@material-ui/icons/Visibility';

function AddNewAddress({
  dialogOpenClose,
  editProgram,
  handleClose,
  organizationId,
  handleSuccessClose,
  ...props
}) {
  const classes = useStyles();
  // const classes1 = useStyles1();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState();
  const [errorMessages, setErrorMessages] = useState({
    errorNote: false,
    errorEditorMaxValue: false,
  });

  const { showMessage } = props;
  const commonAttachments = allowedAttachmentsImages();
  const [bannerImage, setBannerImage] = useState([]);
  const inputFile = useRef(null);

  function uploadSingleFile(e) {
    if (e.target.files == null || e.target.files.length <= 0) return;
    const selectedFile = e.target.files[0];
    if (bannerImage.some((file) => file.fileToSend.name === selectedFile.name)) {
      showMessage('Error', 'File already added', 'error', 3000);
      e.target.value = null;
      return;
    }
    const name = selectedFile.name;
    const lastDot = name.lastIndexOf('.');
    const ext = name.substring(lastDot + 1).toLowerCase(); // Convert to lowercase for case-insensitive comparison
    switch (ext) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        break;
      default:
        showMessage(
          'Error',
          'File format is not allowed,\n Only files with the following extensions are allowed: .jpg .jpeg .png .gif',
          'error',
          3000
        );
        e.target.value = null;
        return;
    }

    setBannerImage((prevImages) => [
      ...prevImages,
      {
        file: URL.createObjectURL(selectedFile),
        fileToSend: selectedFile,
        fileName: selectedFile.name,
      },
    ]);

    e.target.value = null;
  }
  const handleRemoveFile = (index) => {
    const newFileList = [...bannerImage];
    newFileList.splice(index, 1);
    setBannerImage(newFileList);
  };




  const Validate = (errorList) => {

    if (bannerImage.length == 0 && bannerImage.fileToSend == null) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorBannerImg: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorBannerImg: false,
      }));
    }
  };

  const addPhotos = () => {

    let errorList = [];
    Validate(errorList);

    if (errorList.length > 0) return;

    const formData = new FormData();

    formData.append("donorId", organizationId);
    formData.append("Type", "Donor Photo Gallery");
    formData.append("Category", "Donor");


    for (const element of bannerImage) {
      formData.append("AttachmentFiles", element.fileToSend);
    }

    setIsLoading(true);

    PostDataAPI("fdngrantattachments/add", formData, true, "multipart/form-data")
      .then((result) => {
        setIsLoading(false);

        if (result.success && result.data) {
          handleSuccessClose("Gallary images added successfully.");
        } else {
          showMessage("Error", result.message, "error", 3000);
        }
      });

  }

  useEffect(() => {
    if (editProgram) {
    }
  }, []);

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      PaperComponent={DraggableComponent}
      disableBackdropClick
      disableEscapeKeyDown
      open={dialogOpenClose}
      maxWidth="lg"
      {...props}
    >
      <div className={classes.dialogContent}>
        <div className={classes.box}>
          <div className={classes.header} id="draggable-dialog-title">
            <Typography className={classes.title}>Add Photos</Typography>

            <Icon
              className={classes.closeIcon}
              onClick={handleClose}
              color="primary"
            >
              <CloseIcon />
            </Icon>
          </div>

          {isLoading ? <DialogLoader></DialogLoader> : ""}
          <Scrollbars autoHeight autoHeightMax={570}>
            <div className={classes.content}>



              <Grid container spacing={4}>
                <Grid item sm={12} md={12} lg={12} xl={12}>
                  {/* <Label size={12} title="Add Image" mandatory={true} /> */}




                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <input
                      ref={inputFile}
                      id="bannerImg"
                      name="bannerImg"
                      type="file"
                      IsDisabled={false}
                      MaxLength={80}
                      style={{ display: 'none' }}
                      onChange={uploadSingleFile}
                    />
                    <div className={classes.BrowseMain}>
                      <InputBaseField
                        type="text"
                        value={bannerImage.fileName}
                        placeholder="Please Select your file here"
                        MaxLength={80}
                        className={classes.fileInput}
                        readOnly={true}
                        onPaste={(e) => e.preventDefault()}
                        onDrop={(e) => e.preventDefault()}
                      />
                      <a onClick={() => inputFile.current.click()} className={'BrowseButton'}>
                        Browse
                      </a>
                    </div>
                    {errorMessages.errorBannerImg && bannerImage.length == 0 ? (
                      <FormHelperText style={{ color: 'red' }}>Please Select your file</FormHelperText>
                    ) : (
                      ''
                    )}
                    <Typography style={{textTransform: 'inherit'}}>Accepted formats: .jpg, .jpeg, .png, .gif</Typography>
                    {bannerImage.length > 0 && (
                      <div className={classes.fileList}>
                        {bannerImage.map((file, index) => (
                          <div key={index} className={classes.fileName}>
                            {file.fileName}
                            <div>
                              <IconButton className={classes.IconBg} onClick={() => handleRemoveFile(index)}>
                                <CloseIcon className={'IconColor'} />
                              </IconButton>
                            
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </Grid>

                </Grid>
              </Grid>
            </div>
          </Scrollbars>
          <div className={classes.footer}>
            <div className={classes.footerRight}>
              <Button className={classes.backBtn} onClick={handleClose}>
                Close
              </Button>
              <Button onClick={addPhotos} className={classes.changeBtn} >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div >
    </Dialog >
  );
}

export default withSnackbar(AddNewAddress);
